// extracted by mini-css-extract-plugin
export default {"list":"ClientsList_list__BbHmX"};